import { sum } from 'es-toolkit';

import { ProductionComponentInstance } from '@paragon/contract-library';

import { AggregatedTrussStatistics } from '../components/pages/gridTypes';

export function sumComponentValueForInstances(
  productionComponentInstances: readonly ProductionComponentInstance[],
  trussMeasurements: { [analysisSetGuid: string]: AggregatedTrussStatistics },
  multiplierSelector: (trussMeasurements?: AggregatedTrussStatistics) => number,
) {
  return sum(
    productionComponentInstances.map(({ analysisSetGuid }) => multiplierSelector(trussMeasurements[analysisSetGuid])),
  );
}
